import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/benefit-one.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/benefit-two.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/home-hero/2.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/user1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/img/user2.jpg");
